<template>
  <div>
    <div class="main-wrapper">
      <members-sidebar-component v-if="canViewMemberSidebar" />
      <div
        class="container-wrap"
        :class="{ 'no-sidebar': !canViewMemberSidebar }"
      >
        <router-view :key="$route.fullPath" />

        <transition name="fade">
          <div
            v-if="showOverlay"
            class="timesheet-overlay gray-timesheet-overlay"
          >
            <!--            <span class="loading-spinner" />-->
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import MembersSidebarComponent from "./components/MembersSidebarComponent";

export default {
  name: "TimesheetsComponent",
  components: {
    MembersSidebarComponent,
  },
  computed: {
    showOverlay() {
      return this.$store.state.overlay;
    },
    canViewMemberSidebar() {
      return this.$store.state.permission.canAccessAllTimesheets;
    },
  },
};
</script>
<style lang="scss">
div.main-wrapper {
  display: flex;
  flex-direction: row;
}

.timesheet-sidebar {
  width: 327px !important;
  /*background-color: #f6f6f6 !important;*/

  .all-members {
    .all-members-item {
      a {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-start;
        padding: 8px 15px 8px 20px;

        .profile-pic {
          i {
            &:before {
              @include base-transition(ease color 0.1s);
            }
          }
        }

        .name {
          width: calc(100% - 84px);

          h4 {
            font-size: 0.9375rem;
            line-height: 1.5rem;
            font-weight: $roboto-regular;
          }
        }

        &.router-link-active {
          position: relative;
          z-index: 2;
          margin-top: -1px;
          margin-bottom: -1px;
          padding-top: 13px;
          padding-bottom: 13px;

          .name {
            h4 {
              font-weight: $roboto-medium;
            }
          }

          .profile-pic {
            i {
              &:before {
                color: $atto-green;
              }
            }
          }

          .arrow {
            i {
              color: $atto-font-color;
            }
          }
        }

        &.router-link-active,
        &:hover {
          .profile-pic {
            i {
              &:before {
                color: $atto-green;
              }
            }
          }
        }
      }
    }

    .member-list {
      a {
        &.router-link-active,
        &:hover {
          background-color: transparent;
          &:before {
            content: "\E986";
            font-family: "attotime" !important;
            position: absolute;
            right: 23px;
            font-size: 10px;
            color: $atto-font-color;
          }
        }

        &.router-link-active {
          position: relative;
          z-index: 2;
          margin-top: -1px;
          margin-bottom: -1px;
          padding-top: 13px;
          padding-bottom: 13px;
        }
      }
    }

    .invite {
      padding: 11px 0;
      height: 46px;
      i.atto {
        color: $atto-font-color;
        font-size: 0.805rem;
      }
      span {
        font-size: 0.9375rem;
        line-height: 1.5rem;
        color: $atto-font-color;
        font-weight: $roboto-regular;
      }
    }
  }

  .member-list {
    li {
      border: 0;

      a {
        padding: 8px 16px;
        @include base-transition(ease all 0.2s);

        .profile-pic {
          .initials {
            display: inline-flex;
            align-items: center;
            justify-content: center;
            font-size: 0.875rem;
            line-height: 1.5rem;
            font-weight: $roboto-regular;
            font-family: "Roboto", sans-serif;
            color: $atto-not-active;
            background-color: #E3E3E3;
            border-radius: 100%;
            width: 100%;
            height: 100%;
            text-transform: uppercase;
          }
        }
      }

      .name {
        width: calc(100% - 84px);
        margin-right: 0;

        h4 {
          font-weight: $roboto-regular;
          font-size: 0.9375rem;
          line-height: 1.5rem;
        }
      }
    }
  }

  .member-filter {
    border-right: 0;
  }

  .member-list {
    li {
      border-right: 0;

      &.all-members {
        -webkit-transition: ease all 0.2s;
        -moz-transition: ease all 0.2s;
        -ms-transition: ease all 0.2s;
        -o-transition: ease all 0.2s;
        transition: ease all 0.2s;

        .profile-pic {
          align-items: center;
          justify-content: center;
          display: flex;

          i {
            font-size: 1.75rem;

            &:before {
              -webkit-transition: ease all 0.2s;
              -moz-transition: ease all 0.2s;
              -ms-transition: ease all 0.2s;
              -o-transition: ease all 0.2s;
              transition: ease all 0.2s;
            }
          }
        }

        .name {
          h4 {
            font-weight: $roboto-medium;
            font-size: 1rem;
          }
        }

        &:hover {
          /* background-color: $atto-grey;*/
          cursor: pointer;

          .profile-pic {
            i {
              &:before {
                color: $atto-green;
              }
            }
          }

          .arrow {
            i {
              color: $atto-font-color;
            }
          }
        }

        .router-wrap {
          display: flex;
          align-items: center;
          width: 100%;
        }
      }

      &:hover {
        cursor: pointer;

        .name {
          text-decoration: none;

          h4 {
            color: $atto-font-color;
          }
        }
      }
    }
  }
}

.trial-not-expired .timesheet-sidebar {
  top: 108px;
  height: calc(100vh - 108px);
}
.timesheet-overlay {
  position: fixed;
  left: 0;
  top: 60px;
  height: 100%;
  z-index: 1;
  /* background-color: rgba(0, 0, 0, 0.5);*/
  /* width: calc(100% - 327px);*/
  background-color: rgba(239, 239, 239, 0.4);
  width: 100%;
}

.container-wrap {
  /*background-color: #f6f6f6;*/
  width: 100%;
  padding: 0 0 27px 348px;

  .centered-column {
    display: flex;
    flex-direction: column;
    align-self: center;
    margin: 0 auto;
    padding: 0 20px;
  }

  .container-header {
    display: flex;
    flex-flow: row;
    align-items: center;
    justify-content: space-between;
    padding: 18px 10px 18px 20px;
    height: 60px;

    h3 {
      color: $atto-font-color;
      font: 400 1.375rem/1.5rem $roboto-font;
      margin: 0;
    }
  }

  .grid-wrapper {
    display: flex;
    flex-grow: 1;
    justify-items: center;
    flex-direction: column;
    position: relative;
  }

  .content {
    display: flex;
    align-self: center;
    flex-direction: column;
    width: 960px;
    max-width: 100%;
    background-color: $atto-white;
    /*min-height: 90vh;*/
    box-shadow: 1px 2px 4px 0 rgba(199, 199, 199, 0.5);
    border: 1px solid $atto-light-grey;
    margin-bottom: 60px;

    .content-list.b-loaded {
      min-height: 382px;
      height: calc(100vh - 512px);
      position: relative;
      .loading-spinner {
        border: 3px $atto-white solid;
        border-top: 3px $atto-not-active solid;
        border-right: 3px $atto-not-active solid;
        border-bottom: 3px $atto-not-active solid;
      }
    }
  }

  &.no-sidebar {
    padding-left: 0;

    .timesheet-overlay {
      left: 0;
      width: 100%;
    }
  }
}

.content-header {
  display: flex;
  flex-direction: row;
  padding: 20px;
  border-bottom: 1px solid $atto-light-grey;
  align-items: center;
  justify-content: space-between;

  .member {
    display: inline-flex;
    flex-direction: row;
    align-items: center;
  }

  .header-icon {
    width: 40px;
    height: 40px;
    margin-right: 20px;
    display: inline-flex;
    justify-content: center;
    align-items: center;

    i {
      font-size: 18px;
    }

    &.avatar {
      i {
        font-size: 40px;
      }
    }
  }

  .profile-pic {
    width: 36px;
    min-width: 36px;
    max-width: 36px;
    height: 36px;
    margin-right: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    align-content: center;

    i.atto-avatar {
      font-size: 40px;
    }

    img {
      border-radius: 100%;
    }

    span.initials {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      font-size: 0.875rem;
      line-height: 1.5rem;
      font-weight: $roboto-regular;
      font-family: "Roboto", sans-serif;
      color: $atto-not-active;
      background-color: $atto-light-grey;
      border-radius: 100%;
      width: 100%;
      height: 100%;
      text-transform: uppercase;
    }

    &.no-avatar {
      border-radius: 100%;
      width: 40px;
      height: 40px;
      border: 1px solid $atto-not-active;
      padding: 3px;
    }
  }

  h3 {
    font-family: $roboto-font;
    font-weight: $roboto-medium;
    color: $atto-font-color;
    font-size: 1.5rem;
    line-height: 1.75rem;
  }
}

.content-details {
  padding: 40px 50px 32px 26px;
  background-color: $atto-grey;
  border-bottom: 1px solid $atto-light-grey;
  min-height: 216px;

  .total,
  .jobs {
    display: flex;
    flex-direction: row;
    align-items: flex-start;

    i {
      font-size: 18px;
      width: 28px;
      min-width: 28px;
      height: 26px;
      margin-right: 26px;
      color: $atto-dark-grey;
      display: flex;
      justify-content: center;
      align-items: flex-start;
    }

    .details {
      display: flex;
      flex-grow: 1;
      flex-direction: row;

      > div {
        display: inline-flex;

        &:last-child {
          margin-right: 0;
        }
      }
    }
  }

  .total {
    margin-bottom: 31px;

    .details {
      > div {
        display: flex;
        flex-direction: column;
        margin-right: 20px;
        flex-grow: 1;
        flex-basis: 0;
        min-height: 48px;
        position: relative;
        > .loading-spinner {
          position: absolute;
          margin: 0;
          left: 0;
          border-width: 2px;
          width: 22px;
          height: 22px;
        }
      }

      span.label {
        font-size: 0.75rem;
        line-height: 1.25rem;
        font-family: $roboto-font;
        font-weight: $roboto-medium;
        color: $atto-not-active;
      }

      h4 {
        font-family: $roboto-font;
        font-size: 1.25rem;
        line-height: 1.75rem;
        font-weight: $roboto-medium;
      }

      &.loading {
        h4 {
          min-width: 194px;
          height: 32px;
        }
      }
    }
  }

  .jobs {
    .details {
      display: flex;
      flex-direction: column;

      span.label {
        font-size: 0.75rem;
        line-height: 1.25rem;
        font-family: $roboto-font;
        font-weight: $roboto-medium;
        color: $atto-not-active;
        margin-bottom: 4px;
      }

      div.tags {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;

        .job-tag {
          display: inline-flex;
          width: auto;
          flex-grow: unset;
          padding: 4px 12px;
          font-size: 0.875rem;
          line-height: 1.5rem;
          font-family: $roboto-font;
          font-weight: $roboto-medium;
          background-color: $atto-light-grey;
          margin-right: 12px;
          border-radius: 16px;
          margin-bottom: 8px;
        }

        .placeholder-tags {
          display: flex;
          flex-direction: row;
          flex-wrap: wrap;

          .job-tag {
            min-width: 149px;
            min-height: 32px;
          }
        }
      }
    }
  }
}

.table-header {
  padding: 5px 20px;
  display: flex;
  flex-direction: row;
  border-bottom: 1px solid $atto-light-grey;

  span.column-header {
    font-family: $roboto-font;
    font-size: 0.75rem;
    line-height: 1.5rem;
    color: $atto-not-active;
    font-weight: $roboto-regular;
    margin-right: 24px;
    width: 74px;

    &.date {
      width: 60px;
      margin-right: 0;
      min-height: 24px;
    }

    &.name {
      width: 233px;

      i {
        width: 24px;
        height: 24px;
        font-size: 10px;
        color: $atto-dark-grey;
        display: inline-flex;
        justify-content: center;
        align-items: center;
      }

      &.am-pm {
        i {
          margin-left: 10px;
        }
      }
    }
  }
}

.logs-list {
  width: 100%;
  li {
    display: flex;
    flex-direction: row;
    align-items: center;

    border-right: 0;
    border-bottom: 1px solid $atto-light-grey;
    cursor: pointer;

    .has-entries {
      a {
        display: flex;
        flex-direction: row;
        align-items: center;
        width: 100%;

        &:hover {
          color: $atto-font-color;
        }
      }
    }

    > a {
      padding: 20px;
      width: 100%;
    }

    @include base-transition(ease all 0.2s);

    .name {
      margin-right: 24px;
      width: 233px;

      h4 {
        font-weight: $roboto-medium;
      }
    }

    .hour-total {
      max-width: 100%;
      flex-grow: unset;
      width: 100%;
      justify-content: space-between;
      display: flex;

      .hours {
        width: 85px;
        font-family: $roboto-font;
        font-weight: $roboto-regular;
        font-size: 0.875rem;
        line-height: 1.5rem;

        &.total {
          margin-right: 0;
        }
      }
    }

    .arrow {
      margin-right: 0;
      margin-left: auto;
    }

    .week-label {
      background-color: $atto-green;
      border-radius: 0;
      color: $atto-white;
      font-family: $roboto-font;
      font-weight: $roboto-bold;
      text-transform: uppercase;
      font-size: 0.875rem;
      margin-right: 12px;
      text-align: center;
      width: 40px;
      min-width: 40px;
      height: 24px;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .date-interval {
      /*  width: 20.22%;*/
      /* width: 19.57%;*/
      width: 19.6%;
      min-width: 190px;
      font-size: 0.875rem;
      line-height: 1.5rem;
      font-family: $roboto-font;
      color: $atto-green;
      font-weight: $roboto-bold;
      text-transform: uppercase;
    }

    .day-log {
      display: inline-flex;
      flex-direction: row;
      align-items: center;
      margin-right: 30px;
      width: 212px;

      div.calendar-icon {
        width: 40px;
        min-width: 40px;
        height: 40px;
        display: flex;
        flex-direction: column;
        margin-right: 20px;
        margin-left: 1px;
        text-align: center;
        border: 1px solid #f4f4f4;
        border-radius: 5px;
        @include base-transition(ease all 0.2s);

        .day {
          display: inline-flex;
          box-sizing: border-box;
          font-size: 0.625rem;
          line-height: 1.3125rem;
          width: 100%;
          font-family: $roboto-font;
          font-weight: $roboto-bold;
          color: $atto-font-color;
          border-bottom: 1px solid #f4f4f4;
          background-color: $atto-grey;
          text-transform: uppercase;
          justify-content: center;
          @include base-transition(ease all 0.2s);
        }

        .date {
          display: inline-flex;
          box-sizing: border-box;
          font-size: 0.625rem;
          line-height: 0.6875rem;
          width: 100%;
          font-family: $roboto-font;
          font-weight: $roboto-medium;
          color: $atto-not-active;
          justify-content: center;
          @include base-transition(ease all 0.2s);
        }
      }

      .time-interval {
        display: inline-flex;
        flex-direction: row;
        align-items: center;
        min-width: 170px;

        span.start-time,
        span.end-time {
          font-family: $roboto-font;
          font-weight: $roboto-regular;
          color: $atto-font-color;
          font-size: 0.875rem;
          line-height: 1.5rem;
          width: 42px;
        }

        span.pto {
          font-family: $roboto-font;
          font-weight: $roboto-regular;
          color: $atto-font-color;
          font-size: 0.875rem;
          line-height: 1.5rem;
          margin-right: 2px;
        }

        span.start-time {
          margin-right: 2px;
        }

        i {
          width: 24px;
          height: 24px;
          font-size: 10px;
          align-items: center;
          justify-content: center;
          display: inline-flex;
          color: $atto-dark-grey;
        }

        &.am-pm {
          span.start-time,
          span.end-time {
            width: 58px;
          }
        }
      }

      .map-logs {
        width: 40px;
        height: 40px;
        display: inline-flex;
        justify-content: center;
        align-items: center;
        margin-right: 13px;
        margin-left: 3px;
        color: $atto-dark-grey;
        border-radius: 100%;
        @include base-transition(ease all 0.2s);

        &:hover {
          background-color: $atto-light-grey;
          color: $atto-font-color;
        }

        i {
          font-size: 17px;
        }
      }

      span.break-line {
        display: inline-flex;
        width: 2px;
        height: 24px;
        background-color: $atto-light-grey;
        margin-right: 27px;
        margin-left: auto;
      }

      .manual-entries-wrapper {
        display: flex;
        position: absolute;
        margin-left: 214px;
      }

      i.manual-entry {
        align-items: center;
        display: flex;
        font-size: 12px;

        &:before {
          content: "";
          width: 12px;
          display: block;
          height: 12px;
          background: url("../../../fonts/manual-entry.svg");
          -webkit-background-size: contain;
          background-size: contain;
        }
      }
    }

    .customize-log {
      @include base-transition(ease all 0.2s);
      position: absolute;
      z-index: 9999;
      background-color: #fafafa;
      margin: 0;
      min-width: 125px;
      right: 32px;
      padding-left: 20px;
      display: inline-flex;
      align-items: center;
      opacity: 0;

      .edit-log,
      .delete-log {
        display: flex;
        width: 40px;
        height: 40px;
        align-items: center;
        justify-content: center;
        text-align: center;
        background-color: transparent;
        border: 0;
        padding: 0;
        position: relative;

        i {
          position: absolute;
          display: inline-flex;
          width: 40px;
          height: 40px;
          font-size: 18px;
          text-align: center;
          align-items: center;
          justify-content: center;
          color: $atto-font-color;
          border-radius: 100%;
          @include base-transition(ease all 0.15s);

          &:before {
            @include base-transition(ease all 0.15s);
            color: $atto-font-color;
          }
        }

        &:hover {
          cursor: pointer;

          i {
            background-color: $atto-light-grey;

            &::before {
              color: $atto-font-color;
            }
          }
        }
      }
      .edit-log {
        i {
          &:before {
            color: $atto-font-color;
          }
        }
        &:hover {
          i {
            &:before {
              color: $atto-font-color;
            }
          }
        }
      }
      .delete-log {
        i {
          &:before {
            color: $atto-font-color;
          }
        }
        &:hover {
          i {
            &:before {
              color: $atto-red;
            }
          }
        }
      }
    }

    &:hover {
      .day-log {
        div.calendar-icon {
          .day,
          .date {
            background-color: transparent;
          }
        }
      }

      .customize-log {
        opacity: 1;
      }

      .arrow {
        cursor: pointer;

        i {
          color: $atto-font-color;
        }
      }
    }

    .no-entries {
      .day-log {
        .calendar-icon {
          .day,
          .date {
            color: $atto-not-active;
          }
        }

        .time-interval {
          .not-active {
            color: $atto-not-active;
            font-family: $roboto-font;
            font-weight: $roboto-medium;
            font-size: 0.875rem;
            line-height: 1.5rem;
          }
        }
      }

      .add-weekend-entry {
        margin-left: auto;

        &:hover {
          background-color: $atto-white;

          i {
            color: $atto-green;
          }
        }
      }
    }

    &.week-heading {
      .hour-total {
        .hours {
          font-weight: $roboto-medium;
        }
      }
    }

    .has-entries,
    .no-entries {
      display: flex;
      flex-direction: row;
      align-items: center;
      flex-grow: 1;
      width: 100%;
    }

    &:last-child {
      border-bottom: 0;
    }
  }
  &.days {
    li {
      padding: 13px 0 13px 20px;
      height: 50px;
      &.no-entry {
        .no-entries {
          .day-log {
            width: 212px;
            margin-right: 30px;
            div.calendar-icon {
              border-right: 1px solid $atto-light-grey;
              border-left: 1px solid $atto-light-grey;
              border-radius: 0;
              border-top: none;
              border-bottom: none;
              height: 24px;
              margin-right: 10px;

              .day {
                color: $atto-green;
                border: none;
                font-size: 0.75rem;
                line-height: 0.875rem;
                background-color: transparent;
                letter-spacing: 0.6px;
              }
              .date {
                color: #666666;
                line-height: 0.6875rem;
              }
            }
            .time-interval {
              span.end-time {
                font-weight: $roboto-regular;
              }
              span.start-time {
                font-weight: $roboto-regular;
              }
              .not-active {
                color: $atto-font-color;
                font-weight: $roboto-regular;
              }
            }
          }
        }
      }
    }
  }
  /*&.days {
            li {
                padding: 16px 15px 16px 20px;

                &.no-entry {
                    padding: 16px 16px 16px 20px;

                    .no-entries {

                        .day-log {
                            .calendar-icon {
                                .day,
                                .date {
                                    color: $atto-not-active;
                                }
                            }

                            .time-interval {
                                .not-active {
                                    color: $atto-not-active;
                                    font-family: $roboto-font;
                                    font-weight: 500;
                                    font-size: 0.875rem;
                                    line-height: 1.5rem;
                                }
                            }
                        }

                        .add-weekend-entry {
                            margin-left: auto;

                            &:hover {
                                background-color: $atto-white;

                                i {
                                    color: $atto-green;
                                }
                            }
                        }
                    }
                }

                .manual-entries-wrapper {
                    margin-left: auto;
                }
            }
        }*/

  &.months,
  &.weeks {
    li {
      padding: 13px 0 13px 20px;

      .hour-total {
        .hours {
          font-weight: $roboto-medium;
        }
      }

      .day-log {
        .time-interval {
          span.pto {
            font-family: $roboto-font;
            font-weight: $roboto-regular;
            color: $atto-font-color;
            font-size: 0.875rem;
            line-height: 1rem;
            margin-right: 2px;
          }
        }
      }

      /* .manual-entries-wrapper {
                    margin-left: auto;
                }*/
    }
  }
}

ul.day-and-weeks {
  width: 100% !important;
  .week-wrapper {
    padding: 0;
    margin: 0;
    border: 0;
    display: flex;
    flex-direction: column;
    white-space: nowrap;

    .week-heading {
      width: 100%;
      height: 50px;
      display: flex;
      flex-direction: row;
      align-items: center;
      padding: 13px 0 13px 20px;
      border-right: 0;
      border-bottom: 1px solid $atto-light-grey;
      cursor: pointer;

      .week-label {
        background-color: $atto-green;
        border-radius: 0;
        color: $atto-white;
        font-family: $roboto-font;
        font-weight: $roboto-bold;
        text-transform: uppercase;
        font-size: 0.875rem;
        margin-right: 12px;
        text-align: center;
        width: 40px;
        min-width: 40px;
        height: 24px;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .date-interval {
        /* width: 20.22%;*/
        /* width: 19.57%;*/
        width: 19.7%;
        font-size: 0.875rem;
        line-height: 1.5rem;
        font-family: $roboto-font;
        color: $atto-green;
        font-weight: $roboto-bold;
        text-transform: uppercase;
      }

      .hour-total {
        max-width: 100%;
        flex-grow: unset;
        width: 100%;
        justify-content: space-between;
        display: flex;

        .hours {
          width: 85px;
          font-family: $roboto-font;
          font-weight: $roboto-medium;
          font-size: 0.875rem;
          line-height: 1.5rem;

          &.total {
            margin-right: 0;
          }
        }
      }
    }

    .days-log {
      width: 100%;

      li {
        padding: 13px 0 13px 20px;
        border-right: 0;
        border-bottom: 1px solid $atto-light-grey;
        cursor: pointer;
        @include base-transition(ease all 0.2s);
        height: 50px;
        display: flex;
        align-items: center;

        .name {
          margin-right: 24px;
          width: 233px;

          h4 {
            font-weight: $roboto-medium;
          }
        }

        .hour-total {
          max-width: 100%;
          flex-grow: unset;
          width: 100%;
          justify-content: space-between;
          display: flex;

          .hours {
            width: 85px;
            font-family: $roboto-font;
            font-weight: $roboto-regular;
            font-size: 0.875rem;
            line-height: 1.5rem;

            &.total {
              margin-right: 0;
            }
          }
        }

        .arrow {
          margin-right: 0;
          margin-left: auto;
          width: 40px;
          height: 40px;
          display: inline-flex;
          justify-content: center;
          align-items: center;

          i {
            font-size: 14px;
            color: $atto-dark-grey;
            @include base-transition(ease all 0.2s);
          }
        }

        .week-label {
          background-color: $atto-green;
          border-radius: 0;
          color: $atto-white;
          font-family: $roboto-font;
          font-weight: $roboto-bold;
          text-transform: uppercase;
          font-size: 0.875rem;
          margin-right: 12px;
          text-align: center;
          width: 40px;
          min-width: 40px;
          height: 24px;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .date-interval {
          width: 19.6%;
          min-width: 190px;
          font-size: 1.125rem;
          line-height: 1.75rem;
          font-family: $roboto-font;
          color: $atto-font-color;
          font-weight: $roboto-bold;
          text-transform: uppercase;
        }

        .day-log {
          display: inline-flex;
          flex-direction: row;
          align-items: center;
          /* width: 23%;*/

          div.calendar-icon {
            width: 40px;
            min-width: 40px;
            display: flex;
            flex-direction: column;
            margin-left: 1px;
            text-align: center;
            border-right: 1px solid $atto-light-grey;
            border-left: 1px solid $atto-light-grey;
            border-radius: 0;
            border-top: none;
            border-bottom: none;
            height: 24px;
            margin-right: 12px;
            @include base-transition(ease all 0.2s);

            .day {
              display: inline-flex;
              box-sizing: border-box;
              width: 100%;
              font-family: $roboto-font;
              font-weight: $roboto-bold;
              letter-spacing: 0.6px;
              color: $atto-green;
              border: none;
              font-size: 0.75rem;
              line-height: 0.875rem;
              background-color: transparent;
              justify-content: center;
              text-transform: uppercase;
              @include base-transition(ease all 0.2s);
            }

            .date {
              display: inline-flex;
              box-sizing: border-box;
              font-size: 0.625rem;
              line-height: 0.6875rem;
              width: 100%;
              font-family: $roboto-font;
              font-weight: $roboto-medium;
              color: $atto-not-active;
              justify-content: center;
              @include base-transition(ease all 0.2s);
            }
          }

          .time-interval {
            display: inline-flex;
            flex-direction: row;
            align-items: center;
            min-width: 180px;

            span.start-time,
            span.end-time {
              font-family: $roboto-font;
              font-weight: $roboto-regular;
              color: $atto-font-color;
              font-size: 0.875rem;
              line-height: 1.5rem;
              width: 42px;
            }

            span.pto {
              font-family: $roboto-font;
              font-weight: $roboto-regular;
              color: $atto-font-color;
              font-size: 0.875rem;
              line-height: 1.5rem;
              margin-right: 2px;
            }

            span.start-time {
              margin-right: 2px;
            }

            i {
              width: 24px;
              height: 24px;
              font-size: 10px;
              align-items: center;
              justify-content: center;
              display: inline-flex;
              color: $atto-dark-grey;
            }

            &.am-pm {
              span.start-time,
              span.end-time {
                width: 58px;
              }
            }
          }

          .map-logs {
            width: 40px;
            height: 40px;
            display: inline-flex;
            justify-content: center;
            align-items: center;
            margin-right: 13px;
            margin-left: 3px;
            color: $atto-dark-grey;
            border-radius: 100%;
            @include base-transition(ease all 0.2s);

            &:hover {
              background-color: $atto-light-grey;
              color: $atto-font-color;
            }

            i {
              font-size: 17px;
            }
          }

          span.break-line {
            display: inline-flex;
            width: 2px;
            height: 24px;
            background-color: $atto-light-grey;
            margin-right: 27px;
            margin-left: auto;
          }

          i.manual-entry {
            align-items: center;
            display: flex;
            font-size: 16px;

            &:before {
              content: "";
              width: 16px;
              display: block;
              height: 16px;
              background: url("../../../fonts/manual-entry.svg");
              -webkit-background-size: contain;
              background-size: contain;
            }
          }
        }

        .customize-log {
          position: absolute;
          z-index: 9999;
          background-color: #fafafa;
          margin: 0;
          min-width: 125px;
          right: 32px;
          padding-left: 20px;
          display: inline-flex;
          align-items: center;
          opacity: 0;
          @include base-transition(ease all 0.2s);

          .edit-log,
          .delete-log {
            display: flex;
            width: 40px;
            height: 40px;
            align-items: center;
            justify-content: center;
            text-align: center;
            background-color: transparent;
            border: 0;
            padding: 0;
            position: relative;

            i {
              position: absolute;
              display: inline-flex;
              width: 40px;
              height: 40px;
              font-size: 18px;
              text-align: center;
              align-items: center;
              justify-content: center;
              color: $atto-font-color;
              border-radius: 100%;
              @include base-transition(ease all 0.2s);

              &:before {
                @include base-transition(ease all 0.2s);
                color: $atto-font-color;
              }
            }

            &:hover {
              cursor: pointer;

              i {
                color: $atto-font-color;
                background-color: $atto-light-grey;

                &:before {
                  color: $atto-font-color;
                }
              }
            }
          }
          .edit-log {
            i {
              &:before {
                color: $atto-font-color;
              }
            }
            &:hover {
              i {
                &:before {
                  color: $atto-font-color;
                }
              }
            }
          }
          .delete-log {
            i {
              &:before {
                color: $atto-font-color;
              }
            }
            &:hover {
              i {
                &:before {
                  color: $atto-red;
                }
              }
            }
          }
        }

        .add-new-entry {
          display: none;
        }

        &:hover {
          background-color: $atto-grey;
          //cursor: pointer;
          .day-log {
            div.calendar-icon {
              .day,
              .date {
                background-color: transparent;
              }
            }
          }

          .customize-log {
            opacity: 1;
          }

          .arrow {
            cursor: pointer;

            i {
              color: $atto-font-color;
            }
          }

          .not-active {
            display: none;
          }
          .add-new-entry {
            display: flex !important;
            font: $roboto-medium 14px/24px $roboto-font;
            i {
              color: $atto-green;
              font-size: 20px;
              margin-right: 8px;
            }
          }
        }

        &.empty {
          .day-log {
            .calendar-icon {
              .day,
              .date {
                color: $atto-not-active;
              }
            }

            .time-interval {
              .not-active {
                color: $atto-font-color;
                font-family: $roboto-font;
                font-weight: $roboto-regular;
                font-size: 0.875rem;
                line-height: 1.5rem;
              }
              .add-new-entry {
                display: none;
              }
            }
          }

          .add-weekend-entry {
            margin-left: auto;

            &:hover {
              background-color: $atto-white;

              i {
                color: $atto-green;
              }
            }
          }
        }

        &.week-heading {
          .hour-total {
            .hours {
              font-weight: $roboto-medium;
            }
          }
        }

        .has-entries,
        .no-entries {
          display: flex;
          flex-direction: row;
          align-items: center;
          flex-grow: 1;
        }

        .has-entries {
          a {
            display: flex;
            flex-direction: row;
            align-items: center;
            width: 100%;

            &:hover {
              color: $atto-font-color;
            }
          }
        }

        &.no-entry {
          padding: 16px 0 16px 20px;

          .no-entries {
            .day-log {
              .calendar-icon {
                .day {
                  color: $atto-green;
                }
                .date {
                  color: $atto-not-active;
                }
              }

              .time-interval {
                .not-active {
                  color: $atto-font-color;
                  font: $roboto-regular 0.875rem/1.5rem $roboto-font;
                }
              }
            }

            .add-weekend-entry {
              margin-left: auto;

              &:hover {
                background-color: $atto-white;

                i {
                  color: $atto-green;
                }
              }
            }
          }
        }

        &:last-child {
          /*border-bottom: 0;*/
        }

        /* .manual-entries-wrapper {
                        margin-left: auto;
                    }*/
      }
    }

    &:last-child {
      .days-log {
        li:last-child {
          border-bottom: 0;
        }
      }
    }
  }
}

.error-message {
  width: 100%;
  font-size: 0.75rem;
  line-height: 1.25rem;
  font-family: "Roboto", sans-serif;
  color: $atto-red;
  display: inline-block;
  font-weight: $roboto-medium;
  margin-top: 12px;
}

.white-card {
  display: flex;
  flex-direction: column;
  background-color: $atto-white;
  height: 268px;
  box-shadow: 1px 2px 4px 0 rgba(199, 199, 199, 0.5);
  /*   border: 1px solid $atto-light-grey;*/
  margin-bottom: 16px;
}

.session-control-buttons {
  border-left: 1px solid #e3e3e3;
  padding-left: 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  button {
    font: $roboto-medium 0.8125rem/0.9375rem $roboto-font;
    color: $atto-font-color;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: transparent;
    cursor: pointer;
    @include base-transition(ease all 0.1s);
    i.atto {
      width: 24px;
      height: 24px;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      margin-right: 3px;
      @include base-transition(ease all 0.1s);

      &:before {
        color: $atto-font-color;
      }
    }
    &:hover {
      background-color: transparent;
      color: $atto-font-color;
      i {
        background-color: #efefef;
        border-radius: 100%;
      }
    }
  }
}
</style>
